module.exports = __webpack_public_path__ + "static/img/clickin30.c1bbff06.png";